<template>
  <el-select v-model="annualRate" placeholder="选择等次">
    <el-option
      v-for="item in annualRates"
      :key="item.value"
      :label="item.label"
      :value="item.label"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "AnnualEvaRate",
  data() {
    return {
      annualRates: [
        {
          value: 1,
          label: "优秀",
        },
        {
          value: 2,
          label: "称职",
        },
        {
          value: 3,
          label: "基本称职",
        },
        {
          value: 4,
          label: "不称职",
        },
        {
          value: 5,
          label: "未考核",
        },
        {
          value: 6,
          label: "未定等次",
        },
      ],
      annualRate: "",
    };
  },

  watch: {
    annualRate(newVal, oldVal) {
      this.$emit("annualRate", this.annualRate);
    },
  },
};
</script>

<style scoped lang="scss">
</style>